module.exports = __webpack_public_path__ + "img/0-19.6db2dde0.jpg";